import { Link } from 'react-router-dom';
import { BookOpen, LayoutGrid, LifeBuoy, LogIn, ShieldCheck, Ticket } from 'lucide-react';
import { PAGINAS_DOCS, SECCIONES_DOCS } from '../content/registry';
import { Reticula, Tarjeta } from '../components/DocsPiezas';

const ruta = (slug: string): string => PAGINAS_DOCS.find((p) => p.slug === slug)?.ruta ?? '/docs';

/**
 * Portada de la ayuda.
 *
 * Arriba, los cuatro sitios a los que va casi todo el mundo; debajo, el indice
 * completo. Quien llega con una pregunta concreta la resuelve sin leer el
 * indice, y quien llega a enterarse de que hay aqui lo ve entero.
 */
export function PortadaPage(): JSX.Element {
  return (
    <div>
      <h1 className="text-[32px] font-bold leading-tight tracking-tight" style={{ color: 'var(--dk-texto)' }}>
        Centro de ayuda
      </h1>
      <p className="mt-2 max-w-xl text-[15.5px] leading-relaxed" style={{ color: 'var(--dk-texto-tenue)' }}>
        Como entrar, como abrir tus aplicaciones y como pedir ayuda cuando algo no va. Se lee sin
        iniciar sesion, porque quien no puede entrar es justo quien mas necesita leerlo.
      </p>

      <Reticula columnas={2}>
        <Tarjeta icono={LogIn} titulo="Entrar por primera vez" a={ruta('primeros-pasos')}>
          Una sola cuenta para todo. Que hacer si no te deja.
        </Tarjeta>
        <Tarjeta icono={LayoutGrid} titulo="Abrir tus aplicaciones" a={ruta('aplicaciones')}>
          El lanzador, los estados y por que no ves alguna.
        </Tarjeta>
        <Tarjeta icono={LifeBuoy} titulo="Crear un ticket" a={ruta('crear-ticket')}>
          Como contar un problema para que se resuelva a la primera.
        </Tarjeta>
        <Tarjeta icono={Ticket} titulo="Seguir tus tickets" a={ruta('mis-tickets')}>
          Estados, prioridades y cuando se cierra uno.
        </Tarjeta>
      </Reticula>

      <div className="mt-10">
        <p className="mb-4 flex items-center gap-2 text-[13px] font-bold uppercase tracking-wide" style={{ color: 'var(--dk-texto)' }}>
          <BookOpen size={15} style={{ color: 'var(--dk-acento)' }} aria-hidden />
          Todo el contenido
        </p>

        <div className="grid gap-6 sm:grid-cols-2">
          {SECCIONES_DOCS.map((seccion) => (
            <div key={seccion.id}>
              <p className="mb-2 text-[12.5px] font-bold uppercase tracking-wide" style={{ color: 'var(--dk-texto-tenue)' }}>
                {seccion.titulo}
              </p>
              <ul className="space-y-1.5">
                {seccion.paginas.map((pagina) => (
                  <li key={pagina.slug}>
                    <Link
                      to={pagina.ruta}
                      className="block text-[14px] font-medium hover:underline"
                      style={{ color: 'var(--dk-acento-texto)' }}
                    >
                      {pagina.titulo}
                    </Link>
                    <span className="block text-[12.5px] leading-snug" style={{ color: 'var(--dk-texto-tenue)' }}>
                      {pagina.descripcion}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div
        className="mt-10 flex items-start gap-3 rounded-xl border p-4"
        style={{ borderColor: 'var(--dk-borde)', background: 'var(--dk-fondo-sutil)' }}
      >
        <ShieldCheck size={18} className="mt-0.5 shrink-0" style={{ color: 'var(--dk-acento)' }} aria-hidden />
        <p className="text-[13.5px] leading-relaxed" style={{ color: 'var(--dk-texto-suave)' }}>
          Cada aplicacion tiene ademas su propia ayuda, con lo suyo: ED Flow explica los
          diagramas y ED Calendar las tareas. Esta de aqui es la del portal.
        </p>
      </div>
    </div>
  );
}
